export { default as ProductsAppliedFilters } from './ProductsAppliedFilters';
